import { configureStore } from "@reduxjs/toolkit";
import APIResponseSlice from "./slices/APIResponseSlice";
import AnalyticsResponseSlice from "./slices/AnalyticsResponseSlice";
import SegmentResponseSlice from "./slices/SegmentResponseSlice";

export const store = configureStore({
  reducer: {
    // MSALAuth: APISlice,
    APIResponse: APIResponseSlice,
    AnalyticsResponse: AnalyticsResponseSlice,
    SegmentResponse: SegmentResponseSlice,
  },
});
